// extracted by mini-css-extract-plugin
module.exports = {"status":"card_status__mGPEb","ongoing":"card_ongoing__45GZ4","comingSoon":"card_comingSoon__dJWi3","accepted":"card_accepted__RG_QV","expired":"card_expired__sKTXm"};